// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo--3zlT7{border-bottom:1px solid #d9d9d9;box-sizing:border-box;display:block;flex:0 0 auto;height:120px;padding:15px 20px}.image--1fyOB{background-position:center;background-repeat:no-repeat;background-size:contain;display:block;height:100%;width:100%}\n", ""]);
// Exports
exports.locals = {
	"logo": "logo--3zlT7",
	"image": "image--1fyOB"
};
module.exports = exports;
